import React, { useEffect, useState } from "react";
import { Flex, List } from "antd";
import { PlusCircleOutlined } from "@ant-design/icons";
import CustomLoader from "../../../components/common/UI/Loader";
import TicketCard from "./TicketCard";
import AddTicketModal from "./AddTicketModal";
import ENDPOINTS from "../../../services/endpoint";
import GradientButton from "../../../components/common/UI/GradientButton";
import apiInstance from "../../../services/apiService";
import SettingsSidebarHeader from "../../../components/common/SettingsSidebarHeader";
import "./index.scss";
import EasySupport from "../../../components/easySupport";

interface TicketsProps {
  handleBackToPrevious: () => void;
}

interface Ticket {
  attachment: string;
  description: string;
  priority: string;
  status: string;
  subject: string;
  _id: string;
}

const Tickets: React.FC<TicketsProps> = ({ handleBackToPrevious }) => {
  const [loading, setLoading] = useState(false);
  const [ticketsList, setTicketsList] = useState<Ticket[]>([]);
  const [addTicketModalVisible, setAddTicketModalVisible] = useState(false);

  const url = ENDPOINTS.GET_TICKETS;
  const getTickets = async () => {
    setLoading(true);
    try {
      const response = await apiInstance.get(url);
      const data = response.data.data;
      setTicketsList(data);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getTickets();
  }, []);

  return (
    <>
      <div className="tickets-container">
        <SettingsSidebarHeader
          title="Tickets"
          handleBackClick={handleBackToPrevious}
          endElement={
            <GradientButton
              onClick={() => setAddTicketModalVisible(true)}
              className="add-ticket-btn"
              icon={<PlusCircleOutlined />}
            >
              Add
            </GradientButton>
          }
        />

        <div className="ticket-list-container">
          <List
            className="tickets-list"
            loading={{
              spinning: loading,
              indicator: (
                <Flex className="h-full w-full" justify="center" align="center">
                  <CustomLoader />
                </Flex>
              ),
            }}
            dataSource={ticketsList}
            renderItem={(ticket) => (
              <TicketCard
                key={ticket._id}
                title={ticket.subject}
                description={ticket.description}
                priority={ticket.priority}
                status={ticket.status}
                attachment={ticket.attachment}
              />
            )}
          />
        </div>
      </div>

      <AddTicketModal
        visible={addTicketModalVisible}
        onClose={() => setAddTicketModalVisible(false)}
        handleAfterClose={() => getTickets()}
      />

      <EasySupport />
    </>
  );
};

export default Tickets;
